<template>
    <div>
 
<!--        <div class="row columns is-multiline">-->
<!--            <div class="card"   v-for="dataPassThru in dataPassThruImageList" :key="dataPassThru.id"  >-->
<!--&lt;!&ndash;                <header class="card-header">&ndash;&gt;-->
<!--&lt;!&ndash;                    <b-input v-model="title" style="width: 100%"  ></b-input>&ndash;&gt;-->
<!--&lt;!&ndash;                </header>&ndash;&gt;-->
<!--                <div class="card-content"             style="margin-bottom: 1px;padding-bottom: 1px;padding-top: 0.5px;padding-left: 1px;padding-right: 1px">-->
<!--                    <div class="media" >-->
<!--                        <div class="media-left" style="padding-left: 10px">-->
<!--                            <b-button type="is-danger"   icon-left="magnify"  outlined @click="imageModal(dataPassThru.urlTempUploaded)" ></b-button>-->
<!--                        </div>-->
<!--                        <div class="media-content">-->
<!--                            <figure class="image is-96x96">-->
<!--                                <img :src="dataPassThru.urlTempUploaded"  @click="imageModal(dataPassThru.urlTempUploaded)" style="cursor: pointer;" >-->
<!--                            </figure>-->
<!--                        </div>-->
<!--                        <div class="media-right" style="padding-right: 10px">-->
<!--                            <b-button v-if="mode === 'edit' " type="is-danger" outlined @click="$emit('deleteImage',dataPassThru.id)">X</b-button>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <b-input  v-if="mode === 'edit'" v-model="dataPassThru.title" style="width: 100%"  ></b-input>-->
<!--            </div>-->

<!--        </div>-->

        <div class="columns is-multiline">
        <div class="column is-one-quarter-desktop is-half-tablet"   v-for="dataPassThru in dataPassThruImageList" :key="dataPassThru.id" >
<!--            <div  :class=" plus ? 'card has-background-danger-light' : 'card '" >-->
            <div  :class=" plus ? 'card ' : 'card '" >

                <div class="card-image  ">
                     <figure class="image is-4by3"  >
                      <img :src="dataPassThru.urlTempUploaded"  >
                     </figure>

                    <div class="card-content is-overlay is-clipped">
                          <span  v-if="dataPassThru.title" class="tag is-info has-text-light" style="opacity: 0.7;">
                           {{dataPassThru.title}}
                          </span>
                    </div>
                </div>
                <footer class="card-footer">
                    <a class="card-footer-item" @click="imageModal(dataPassThru.urlTempUploaded)">
                        <b-icon
                                icon="magnify"
                                size="is-medium">
                        </b-icon>
                    </a>
                    <a v-if="modeThumbnailImageList === 'edit'" class="card-footer-item"  @click="deleteImage(dataPassThru.fileNameUploaded)">
                        <b-icon
                                icon="delete"
                                size="is-medium"
                                type="is-danger" >
                        </b-icon>
                    </a>
                </footer>
            </div>




        </div>
        </div>



        <b-modal :active.sync="isImageModalActive">
            <p class="image ">
                <img :src=dataUrl>
            </p>
        </b-modal>

    </div>
</template>

<script>
    /* eslint-disable no-console */
    export default {
        name: "ThumbnailImageList",
        props:{
            dataPassThruImageList : Array  , //  [  { id: "",  file : null, urlTempUploaded: "", title : "" ,fileNameUploaded:"" ,fresh : "" }  , .... ]
            modeThumbnailImageList : String , //    edit  view
            plus : Boolean
        },
        methods:{
             deleteImage(fileNameUploaded){
                 this.$emit('deleteImage',fileNameUploaded)
             },
            imageModal(dataUrl){
                if(dataUrl !== "") {
                    this.dataUrl = dataUrl
                }else{
                    this.dataUrl = 'imgnotaval.jpg'
                }
                this.isImageModalActive = true
            }
        },
        data(){
            return {
                isImageModalActive : false,
                dataUrl : ""
            }
        }
    }
</script>

<style scoped>
    img{
        cursor: pointer;
        width:100%;
        height:100%;
        object-fit: contain;

    }
    /*.card{*/
    /*    border: 5px solid #555;*/
    /*}*/



</style>